import { render } from "./expertAdd.vue?vue&type=template&id=0a07e34a&scoped=true"
import script from "./expertAdd.vue?vue&type=script&lang=js"
export * from "./expertAdd.vue?vue&type=script&lang=js"

import "./expertAdd.vue?vue&type=style&index=0&id=0a07e34a&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a07e34a"]])

export default __exports__